module.exports = __webpack_public_path__ + "images/b8a989ce4b5c7b61c26705bbd3349a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/intro-main00.jpg
// module id = ./webpack/assets/img/intro-main00.jpg
// module chunks = 0